import { defineMessages } from 'react-intl';

export default defineMessages({
  content: {
    id: 'accountCards.guestCardHome.content',
    defaultMessage:
      'Get a free digital Starbucks Card when you join { starbucksRewardsTrademark }, or register a gift card you already have.',
    description: 'Content for unauth cards screen',
  },
});
